import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { ShareObjectsController } from '@commoncore/controller/ShareObjectsController';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { TagInputModule } from 'ngx-chips';
// import { FacebookService, UIParams, UIResponse } from 'ngx-facebook';
import { Observable } from 'rxjs';


@Component({
  standalone:true,
  selector: 'app-share-link',
  templateUrl: './share-link.component.html',
  styleUrls: ['./share-link.component.scss'],
  imports:[DependenciesModule,TagInputModule]
})

export class ShareLinkComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() setShare = new EventEmitter();
  universalService: any;
  listService:any;
  
  controller: any;
  implRef: any;
  showSharePopUp:boolean = false;
  copyText : string = "Copy Link";
  shareLink:any;
  maximize : boolean = true;
  selectedTag: any;
  fileopsctrl: any;
  suggestedEmails: any = [];
  emailList:any =[];
  http: any;
  socialSahreLink:any
  fbDiscription: string;
  fbPicture: any;
  showShareModal: boolean = false;
  showInviteModal: boolean = false;
  showShareLinkModal : boolean = false;
  buttonText:string = "";
  localStorageSvc: LocalStorageSvc;
  
  
  constructor(
    private globalService: GlobalService, 
    public cleverTapEventsService: CleverTapEventsService, 
    // private fb: FacebookService, 
    private changeDetector: ChangeDetectorRef
  ) {
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.setEnvObjects(this.globalService);
  }
   

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && (this.showInviteModal || this.showShareModal || this.showShareLinkModal)) {
      if(this.universalService.showEnhancedShareLink && $('#share-modal').is(':visible')) {
        AppEvents.optionSelected.next({shareLink: false});
        this.implRef.receiverIds = [];
        this.implRef.mailError.error="";
        this.universalService.isAnyChange = false;
        this.universalService.showModalBackdrop();
        return;
      }
      this.listService.deSelectAll(event);
      this.implRef.receiverIds = [];
      this.implRef.mailError.error="";
    }
    // else if(event.key === "Enter" && document.activeElement.tagName != "INPUT" && document.activeElement.tagName != "TEXTAREA" && this.implRef.enableButton && this.implRef.receiverIds.length>0){
    //   this.sendShareLinkToSelectedRecipients();
    // }
  }

  ngOnInit(): void {
    this.controller=ShareObjectsController.getInstance(this.globalService);
    this.controller.setEnvObjects(this.globalService);
    this.implRef = this.controller.shareObjectsImplementation;
    this.fileopsctrl = this.controller.fileOpsController;
    this.implRef.commentAlert = "";
    this.implRef.receiverIds = [];
    AppEvents.optionSelected.subscribe(event => {
      if(event["share"]){
        this.showInviteModal = false;
        this.showShareLinkModal = false;
        this.buttonText = "Share"
        this.createShareLink();
        // this.maximize = true;
        // this.transformModal();
        this.changeDetector.detectChanges();
      } else if(event["invite"]){
        this.buttonText = "Invite"
        this.showShareModal = false;
        this.createInviteLink();
        // this.maximize = true;
        // this.transformModal();
        this.changeDetector.detectChanges();
      } else if(event["shareLink"]){
        this.universalService.popUpToBeOpened = "dummy";
        this.buttonText = "Share Link"
        this.showShareModal = false;
        this.showInviteModal = false;
        if(!this.universalService.isUserOnSharedLinkByMe) {
          if(this.implRef.universalShareUrl && this.universalService.universalShareUrl != "") {
            this.shareLink = this.implRef.universalShareUrl;
            this.showShareForUniversalShareLink();
          } else {
            this.createUniversalShareLink();
          }
        } else {
          this.shareLink = this.universalService.selectedFile.shareURL;
          if(this.universalService.selectedFile.FullObject != null) {
            this.shareLink = this.universalService.selectedFile.FullObject.shareURL;
          }
          this.showShareForUniversalShareLink();
        }
        // this.maximize = true;
        // this.transformModal();
        this.changeDetector.detectChanges();
      } else if(event["closeAll"] || event["shareLink"] == false){
        this.showShareModal = false;
        this.showInviteModal = false;
        this.showShareLinkModal = false;
        this.changeDetector.detectChanges();
       if(!this.universalService.showEnhancedShareLink)
        this.universalService.disableModalBackdrop();
      }
    })


  }
  async createShareLink(){
    let self = this;
    this.universalService.showModalBackdrop();
    this.universalService.showLoader = true;
    this.shareLink = await this.controller.createShareLinkForSelectedObjects(this.universalService.selectedNodes);
    this.sendShareLinkClecertapEvent();
    if(this.shareLink != ""){
      this.showShareModal = true;
    }
    this.suggestedEmails = await this.fileopsctrl.getSuggestedEmails();
    this.suggestedEmails.contactEmail.map(item =>{
      this.emailList.push(item.email)
    })
    if(this.shareLink && this.shareLink != ""){
      this.getSocialShareLink();
    }else{
      this.universalService.showLoader = false;
    }
    
  }

  getSocialShareLink(){
    if(this.shareLink != null){
      this.universalService.showLoader = false;
      if(this.universalService.isMobileDevice){
   
        let t1 = "JioAICloud Share";
        let u1 = this.shareLink;
        let nav: any;
        nav = window.navigator;
        if(nav.canShare && nav.canShare({ url: u1 })){
          nav.share({
            title:t1,
            url:u1
          }).then(()=>{
            this.universalService.showLoader = false;
            this.universalService.popUpToBeOpened = ''
            this.universalService.selectionNodeNotNeedtoclear=true
            this.closePopUp();
          }).catch(()=>{
            this.universalService.popUpToBeOpened = ''
            this.universalService.selectionNodeNotNeedtoclear=true
            this.closePopUp();
          })
        }
      }


      this.showSharePopUp = true;
    }
    this.setFacebookParam(this.universalService.selectedNodes)
    var uri = this.shareLink.toString();
    this.socialSahreLink = encodeURIComponent(uri);
  }

  sendShareLinkClecertapEvent(){
    let self = this
    if(self.universalService.selectedTab == 'Album Details'){
      //let userID = self.localStorageSvc.getUserId(true);
      let userID = USER_DETAILS["USER_DETAILS"]["userId"];
      let inviter = ''
      let ownerUserId = self.universalService.currentAlbum.owner.ownerUserId
      if( ownerUserId == userID){
        inviter = "OWNER"
      }else{
        inviter = "MEMBER"
      }
      self.cleverTapEventsService.sharLinkGeneartedAlbums(self.universalService.selectedNodes,inviter)
    }else{
      self.cleverTapEventsService.sharLinkGenearted(self.universalService.selectedNodes, self.universalService.currentTab);
    }
  }

  async createInviteLink(){
    var resp = await this.controller.createInviteLink();
    this.shareLink = resp["inviteUrl"]
    if(this.shareLink && this.shareLink != ""){
      this.showInviteModal = true;
      this.getSocialShareLink();
    }else{
      this.universalService.showLoader = false;
    }
    this.sendInviteLinkCTEvent();
  }

  async createUniversalShareLink() {
    let self = this;
    this.universalService.showModalBackdrop();
    this.universalService.showLoader = true;
    var apiResponse = await this.controller.getUniversalShareLinkForSelectedObjects(this.universalService.selectedNodes);
    if(apiResponse != null && apiResponse['shareURL'] != null && apiResponse['shareURL'] != "") {
      this.shareLink = apiResponse['shareURL'];
      this.showShareLinkModal = true
    }
    this.suggestedEmails = await this.fileopsctrl.getSuggestedEmails();
    this.suggestedEmails.contactEmail.map(item =>{
      this.emailList.push(item.email)
    })
    if(this.shareLink && this.shareLink != ""){
      this.getSocialShareLink();
    }else{
      this.universalService.showLoader = false;
    }
  }

  async showShareForUniversalShareLink() { // method caled when we already have universal shareLink generated
    let self = this;
    this.universalService.showModalBackdrop();
    this.universalService.showLoader = true;
    this.showShareLinkModal = true;
    this.suggestedEmails = await this.fileopsctrl.getSuggestedEmails();
    this.suggestedEmails.contactEmail.map(item =>{
      this.emailList.push(item.email)
    })
    if(this.shareLink && this.shareLink != ""){
      this.getSocialShareLink();
    }else{
      this.universalService.showLoader = false;
    }
  }

  sendInviteLinkCTEvent(){
    let self = this
    //let userID = self.localStorageSvc.getUserId(true);
    let userID = USER_DETAILS["USER_DETAILS"]["userId"];
    let inviter = ''
    let ownerUserId = self.universalService.currentAlbum.owner.ownerUserId
    if( ownerUserId == userID){
      inviter = "OWNER"
    }else{
      inviter = "MEMBER"
    }
    self.cleverTapEventsService.inviteUsrToAlbum(self.universalService.currentAlbum.filesCount,inviter)
  }
  setFacebookParam(selectedNodes){
    if(selectedNodes.length == 1 && selectedNodes[0].objectType == 'FR'){
        this.fbDiscription = 'Folder'
    }else{
      this.fbDiscription = 'View the files shared with you on JioAICloud.'
    }
    if(this.universalService.currentAlbum!=undefined && this.showInviteModal){
      this.fbPicture = this.universalService.currentAlbum["boardCoverPic"]
    }else if(selectedNodes[0].imageTranscodeUrl != undefined){
      this.fbPicture = selectedNodes[0].imageTranscodeUrl;
    }else{
      this.fbPicture =  'https://static.jiocloud.com/resource/img/Jio-Drive_Logo_Red.png'
    }
  }
  public requestAutocompleteItems = (text: string): Observable<Response> => {
    return this.suggestedEmails;
  };

  async sendShareLinkToSelectedRecipients(){
    var mailIds = [];
    var emailResp;
    this.implRef.receiverIds.map(id=>{
      if(this.showInviteModal){
        mailIds.push(id);
      }else{
        mailIds.push({
          "emailId":id
        })
      }
    })
    this.implRef.comment = this.implRef.commentMessage;
    if(this.showInviteModal){
      emailResp = await this.controller.InviteFriendsToJoinAlbum(mailIds,this.shareLink);
    }else{
      this.cleverTapEventsService.publicShareLinkEmailed();
      emailResp = await this.controller.shareLinkToRecipients(mailIds,this.shareLink);
    }
   if(emailResp == null){
     var msg = "";
     if(this.showInviteModal){
       msg = "An invite link for album " + '"' + this.universalService.currentAlbum["boardName"] + '"' + " sent to "
     }else{
      msg  = "A link to the selected files was sent to ";
     }
     if(mailIds.length == 1){
       msg = msg + (this.showInviteModal ? mailIds[0] : mailIds[0]["emailId"])
     }else{
      msg = msg + (this.showInviteModal ? mailIds[0] : mailIds[0]["emailId"]) + " and " + (mailIds.length-1) + " others"
     }
    this.universalService.showToast(msg,"success")
    this.implRef.commentMessage = "";
    this.universalService.isAnyChange = false;
    if(!this.showShareLinkModal) {
      this.listService.deSelectAll(null);
    }
    this.closePopUp();
   }
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc()
  }

  closePopUp(){
    this.universalService.isAnyChange = false;
    $('.ng2-tag-input__text-input').val('');
    this.implRef.mailError={"error":"","type":""};
    this.implRef.receiverIds = [];
    this.showShareModal = false;
    this.changeDetector.detectChanges();
    if(!this.showShareLinkModal) {
      $('#custome_backdrop').remove();
      this.close.emit();
    } else {
      this.showShareLinkModal = false;
      this.changeDetector.detectChanges();
    }
  }

  onItemRemoved(event){
    this.implRef.onItemRemoved(event)
  }

  onItemAdded(event){
    this.implRef.onItemAdded(event)
    setTimeout(() => {
      this.calculateScrollTop()
    }, 10);

  }

  validateComments(event,comment){
    this.implRef.validateComments(event,comment);
  }

  onTagEdited(event){
    //this.loggerService.log("onTagEdited",event,this.implRef.receiverIds);
    
    var find = this.implRef.receiverIds.indexOf(this.selectedTag);
    if(find>=0){
      this.implRef.receiverIds[find] = event 
      this.selectedTag = "";
      this.implRef.validateEmailId(this.implRef.receiverIds);
      //this.implRef.checkIfAllTheRequiredFeildsArePresentToEnableTransfer();
    }
  }

  // onTextChange(event){
  //   var keypressed = event[event.length-1];
  //   if(this.globalService.isMobileDevice && (keypressed == "," || keypressed == " ")){
  //     let el = document.querySelector('.emailTo')
  //     var key = event.split(keypressed)[0];
  //     this.loggerService.log("key is ==>>",key);
  //     this.implRef.receiverIds.push(key);
  //     this.onItemAdded();
  //     $('form').trigger("reset");
  //     (<HTMLElement>document.querySelector('.emailTo')).style.display = 'none';
  //     el.classList.add('focusedInput')
  //   }
  // } 

  SelectedTagForEditing(event){
    //this.loggerService.log("event on select",event);
    this.selectedTag = event
  }

  copyLink(option){
    const el = document.createElement("input");
    document.body.appendChild(el);
    el.value = this.shareLink
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if(option == "Copy"){
    this.copyText = "Copied"
    setTimeout(()=>{
      this.copyText = "Copy Link"
      },3000)
    }else if(option == "WhatsApp"){
    }
    else if(option == "Fb"){
      this.shareOnFacebook();
    }
    else if(option == "Twtr"){
      // this.shareOnTwitter();
    }
  }

  shareOnFacebook() {
    // const initParams: InitParams = {
    //   appId: ENV_CONSTANTS.fbAppId,
    //   autoLogAppEvents: true,
    //   status: true,
    //   xfbml: true,
    //   version: ''
    // };

    // this.fb.init(initParams);
    // const params: UIParams = {
    //   href: this.shareLink,
    //   method: 'share',
    //   display: "popup",
    //   picture: this.fbPicture,
    //   description: this.fbDiscription
    // };
    // this.fb.ui(params)
    //   .then((res: UIResponse) => )
    //   .catch((e: any) => console.error(e));
    // FB.init({
    //   appId      : ENV_CONSTANTS['fbAppId'],
    //   cookie : true,
    //   version    : 'v18.0'
    // });
    // FB.ui({
    //   method: 'share',
    //   display: 'popup',
    //   href: this.shareLink,
    // }, function(response){});
  }

  shareOnTwitter(){
    // var uri = this.shareLink.toString();
    // var encodedUrl = encodeURIComponent(uri);
    // let url = 'https://twitter.com/intent/tweet?text='+ encodedUrl;
    // let newwindow=window.open(url,'name','height=500,width=520,top=200,left=300,resizable, noopener, noreferrer');
    // if (window.focus) {
    //   newwindow.focus()
    // }
  }


  // transformModal(){
  //   this.maximize = !this.maximize;
  //   if(this.maximize){
  //     $('#share-modal .modal-dialog').removeClass("modal-md");
  //     $('#share-modal .modal-dialog').addClass("modal-lg");
  //     // $(".sharingOptions").removeClass("ml-3");
  //     // $(".sharingOptions").addClass("ml-5");
  //   }else{
  //     $('#share-modal .modal-dialog').removeClass("modal-lg")
  //     $('#share-modal .modal-dialog').addClass("modal-md");
  //     // $(".sharingOptions").removeClass("ml-5");
  //     // $(".sharingOptions").addClass("ml-3");
  //   }
  // }

  calculateScrollTop(){
    var chipsCont = document.querySelector('.receipientsList') as any;
    chipsCont.scrollTop = chipsCont.scrollHeight;
  }


}
